import { Box, Typography } from "@mui/material";
import DialogBox from "components/DialogBox";
import { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
import { useProductsStyles } from "./ProductStyles";
import scanQrCode from "assets/Icons/scanQRCode.jpg";

interface WeChatModalInterface {
  readonly openWeChatModal: boolean;
  readonly setOpenWeChatModal: Dispatch<SetStateAction<boolean>>;
}
export const WeChatModal: React.FC<WeChatModalInterface> = ({
  openWeChatModal,
  setOpenWeChatModal,
}) => {
  const intl = useIntl();
  const classes = useProductsStyles();
  return (
    <>
      <DialogBox
        isModalOpen={openWeChatModal}
        handleModalClose={() => setOpenWeChatModal(false)}
        showLogo={false}
        content={
          <>
            <Box>
              <Box className={classes.modalHeader}>
                <Typography className={classes.scanQrTitle}>
                  {intl.formatMessage({
                    id: I18nKey.SCANQR_TITLE,
                  })}
                </Typography>
              </Box>
              <Box className={classes.qrCodeImg}>
                <img src={scanQrCode} width="88%" />
              </Box>
            </Box>
          </>
        }
      ></DialogBox>
    </>
  );
};
